import React from "react";

export const EmailIcon = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="41" height="41" rx="8.5" fill="#222222" />
    <rect x="0.5" y="0.5" width="41" height="41" rx="8.5" stroke="black" />
    <circle cx="21" cy="21" r="16" fill="url(#paint0_linear_19993_148821)" />
    <path
      d="M29 13H13C11.9 13 11.01 13.9 11.01 15L11 27C11 28.1 11.9 29 13 29H29C30.1 29 31 28.1 31 27V15C31 13.9 30.1 13 29 13ZM28.6 17.25L21.53 21.67C21.21 21.87 20.79 21.87 20.47 21.67L13.4 17.25C13.2997 17.1937 13.2119 17.1177 13.1419 17.0265C13.0719 16.9352 13.0211 16.8308 12.9926 16.7194C12.9641 16.608 12.9585 16.4919 12.9762 16.3783C12.9938 16.2647 13.0343 16.1558 13.0953 16.0583C13.1562 15.9608 13.2363 15.8767 13.3307 15.811C13.4251 15.7453 13.5319 15.6995 13.6445 15.6763C13.7571 15.6531 13.8733 15.653 13.986 15.6759C14.0986 15.6989 14.2055 15.7445 14.3 15.81L21 20L27.7 15.81C27.7945 15.7445 27.9014 15.6989 28.014 15.6759C28.1267 15.653 28.2429 15.6531 28.3555 15.6763C28.4681 15.6995 28.5749 15.7453 28.6693 15.811C28.7637 15.8767 28.8438 15.9608 28.9047 16.0583C28.9657 16.1558 29.0062 16.2647 29.0238 16.3783C29.0415 16.4919 29.0359 16.608 29.0074 16.7194C28.9789 16.8308 28.9281 16.9352 28.8581 17.0265C28.7881 17.1177 28.7003 17.1937 28.6 17.25Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_19993_148821"
        x1="37"
        y1="21"
        x2="5"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0D0D0D" />
        <stop offset="1" stopColor="#2F2F2F" />
      </linearGradient>
    </defs>
  </svg>
);
